<template>
  <base-modal overlay-class="mini_games_modal" modal-content-class="modal modal__content mini_games_modal">
    <div class="modal__body">
      <h1>
        <span>{{ getTranslations.modal_pre_game_puzzle_title_pt1 }}<br></span>
        {{ getTranslations.modal_pre_game_puzzle_title_pt2 }}
      </h1>

      <p>{{ getTranslations.modal_pre_game_puzzle_subtitle }}</p>

      <base-image src="/static/images/puzzle/puzzle_sign.svg" image-class="modal_icon_main" alt="puzzle icon" />
    </div>

    <div class="modal__footer">
      <p>
        {{ getTranslations.modal_pre_game_puzzle_description_pt1 }}
        <span>{{ timerForPuzzleGame }} {{ getTranslations.modal_pre_game_puzzle_description_pt2 }}</span>
        {{ getTranslations.modal_pre_game_puzzle_description_pt3 }}
      </p>

      <p>{{ getTranslations.modal_pre_game_puzzle_description_pt4 }}</p>

      <base-button
        v-if="canPlay"
        container-default-class=""
        container-class="ti_btn--main"
        @button:click="$emit('play:puzzle')"
      >
        {{ getTranslations.modal_pre_game_puzzle_button_proceed }}
      </base-button>

      <div
        v-else
        class="error_text"
        style="margin-bottom: 16px"
      >
        {{ getTranslations.modal_pre_game_puzzle_error_already_played }}
      </div>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseModal from '../BaseModal.vue';
import BaseImage from '../../image/BaseImage.vue';
import BaseButton from '../../button/BaseButton.vue';

export default {
  name: 'PrePuzzleGameModal',
  emits: ['play:puzzle'],
  components: {
    BaseModal,
    BaseImage,
    BaseButton,
  },
  props: {
    canPlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('common', [
      'timerForPuzzleGame',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/modal/game/PrePuzzleGameModal.vue